// Polyfill for process (required by React Flow 11+)
if (typeof window !== 'undefined') {
    if (!window.process) {
        window.process = {};
    }
    if (!window.process.env) {
        window.process.env = {};
    }
    if (!window.process.env.NODE_ENV) {
        window.process.env.NODE_ENV = 'production';
    }
    window.global = window;
}
